export const IMAGES = {
  hero: "/photos/hero-zellige.jpg",
  palace: "/photos/palace-arches.jpg",
  violin: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxvcmNoZXN0cmElMjBwZXJmb3JtYW5jZSUyMGxpdmUlMjBzdGFnZXxlbnwwfHx8fDE3ODg2NTMxNTB8MA&ixlib=rb-4.1.0&q=85",
  oud: "https://images.pexels.com/photos/19947409/pexels-photo-19947409.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ensemble: "https://images.pexels.com/photos/34126893/pexels-photo-34126893.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  santour: "https://images.unsplash.com/photo-1769867303648-0a3ed8115440?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtaWRkbGUlMjBlYXN0ZXJuJTIwbXVzaWNpYW5zJTIwb3VkJTIwaW5zdHJ1bWVudHxlbnwwfHx8fDE3ODg2NTMxNTB8MA&ixlib=rb-4.1.0&q=85",
  stage: "https://images.unsplash.com/photo-1765234829366-dd3cfefa1ba9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzMzl8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwc3RhZ2UlMjBsaWdodHMlMjBnb2xkJTIwYXRtb3NwaGVyZXxlbnwwfHx8fDE3ODg2NTMxNTB8MA&ixlib=rb-4.1.0&q=85",
  patioWide: "/photos/patio-wide.jpg",
  patioClose: "/photos/patio-close.jpg",
};

export const STREAMS = {
  spotify: "https://open.spotify.com/search/1001%20Nights%20Orchestra",
  apple: "https://music.apple.com/us/search?term=1001%20Nights%20Orchestra",
  youtube: "https://www.youtube.com/1001nightsorchestra",
  instagram: "https://www.instagram.com/explore/tags/1001nightsorchestra/",
  facebook: "https://www.facebook.com/search/top?q=1001%20Nights%20Orchestra",
};

export const CHAPTERS = [
  {
    num: "01",
    title: "The Inception",
    paragraphs: [
      "In 1987, inside Austin\u2019s storied Chicago House, a circle of musicians began gathering to play, experiment, and improvise together. Before long, those sessions became 1001 Nights Orchestra.",
      "What began with Persian folk and popular music soon expanded into something broader: a living repertoire shaped by the musical traditions of the Middle East, Latin America and the Balkans.",
      "Nearly four decades later, that musical journey is still unfolding.",
    ],
    image: "/photos/chicago-house.jpg",
    imageAlt: "The Chicago House sign glowing at night in downtown Austin",
    artifact: true,
    caption: "Chicago House \u25C8 Austin, TX",
  },
  {
    num: "02",
    title: "The Growth Years",
    paragraphs: [
      "Over the years, 1001 Nights Orchestra evolved through many lineups, each musician leaving an imprint on the ensemble.",
      "Along the way it recorded several albums and launched a sister project, Ojal\u00E1, bringing Middle Eastern repertoire into conversation with Latin American melodies and rhythms.",
      "The ensemble also composed and performed an award-winning score for the 1924 silent classic The Thief of Bagdad.",
      "Beyond the stage, it helped create Austin\u2019s annual Nowruz celebrations at Central Market, bringing music, culture and community together around the Persian New Year.",
    ],
    image: "/photos/thief-of-bagdad.jpg",
    imageAlt: "Vintage illustrated cover of The Thief of Bagdad, based on the Douglas Fairbanks film",
    artifact: true,
    caption: "The Thief of Bagdad \u25C8 1924",
    secondImage: "/photos/nowruz-poster.jpg",
    secondImageAlt: "Framed poster for the 5th annual Nowruz Festival and Persian New Year Celebration at Central Market, featuring Ojalá",
    secondCaption: "Nowruz Festival \u25C8 Central Market",
  },
  {
    num: "03",
    title: "Still Unfolding.",
    paragraphs: [
      "Today, 1001 Nights Orchestra continues to evolve while staying rooted in the traditions that first brought the group together.",
      "The ensemble\u2019s sound still moves freely across borders\u2014shaped by the personalities, experiences, and musical voices of the players who carry it forward.",
      "The repertoire keeps growing. The lineup keeps evolving. There are still more nights \u2014 and more music \u2014 ahead.",
    ],
    image: IMAGES.patioWide,
    imageAlt: "1001 Nights Orchestra performing on the patio at Chocolatería San Ginés, Austin",
  },
];

// date: YYYY-MM-DD. Shows are split into upcoming/past automatically by date.
// status (optional, upcoming only): "Tickets" | "Free" | "Sold Out" | "Private"
// ticketUrl (optional): when set, an upcoming show gets a Tickets/RSVP button linking there
export const SHOWS = [
  {
    id: "safdf-2026",
    date: "2026-03-22",
    title: "San Antonio Folk Dance Festival",
    venue: "St. Sophia Greek Orthodox Church",
    address: "2504 N. St. Mary's Street",
    city: "San Antonio, TX",
    details: "SAFDF workshops featuring international folk dance teaching, music, parties and camaraderie.",
  },
  {
    id: "san-gines-patio",
    date: "2026-04-09",
    title: "Music on the Patio",
    venue: "Chocolatería San Ginés",
    address: "2072 S Lamar Blvd",
    city: "Austin, TX",
    details: "A night of music with a focus on our Spanish and Latin repertoire.",
    photos: [
      { src: IMAGES.patioWide, alt: "The ensemble under string lights on the San Ginés patio" },
      { src: IMAGES.patioClose, alt: "Bass, clarinet, riq, darbuka, accordion and guitar mid-set" },
    ],
  },
  {
    id: "ifd-april",
    date: "2026-04-24",
    title: "Performance for the International Folk Dancers",
    venue: "Hancock Recreation Center",
    address: "811 E. 41st St",
    city: "Austin, TX",
    details: "A live music performance for the International Folk Dancers group, with Armenian and other dance lessons.",
  },
  {
    id: "aftm-world-music-night",
    date: "2026-07-17",
    title: "AFTM World Music Night",
    venue: "Batch Craft Beer & Kolaches",
    address: "3220 Manor Rd",
    city: "Austin, TX",
    status: "Free",
    details: "A world music showcase hosted at Batch Craft Beer & Kolaches.",
  },
  {
    id: "ifd-august",
    date: "2026-08-28",
    title: "Performance for the Austin International Folk Dancers",
    venue: "Hancock Recreation Center",
    address: "811 E. 41st St",
    city: "Austin, TX",
    status: "Free",
    details: "A return performance for the Austin International Folk Dancers, featuring a curated set of traditional dance music and lessons.",
    photos: [
      { src: "/photos/ifd-aug-1.jpg", alt: "Victor on fretless bass, Don on accordion, Sonique on darbuka and Javier singing beneath the brick arches of Hancock Recreation Center" },
      { src: "/photos/ifd-aug-2.jpg", alt: "Sonique leading a circle of folk dancers through the steps" },
      { src: "/photos/ifd-aug-3.jpg", alt: "Dancers mid-step, one with a red scarf, on the Hancock Recreation Center floor" },
    ],
  },
];

const parseDate = (d) => new Date(`${d}T00:00:00`);

export const splitShows = (now = new Date()) => {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const upcoming = SHOWS.filter((s) => parseDate(s.date) >= today).sort((a, b) => a.date.localeCompare(b.date));
  const past = SHOWS.filter((s) => parseDate(s.date) < today).sort((a, b) => b.date.localeCompare(a.date));
  return { upcoming, past };
};

export const formatShowDate = (date) => {
  const d = parseDate(date);
  return {
    day: String(d.getDate()).padStart(2, "0"),
    month: d.toLocaleString("en-US", { month: "short" }),
    year: String(d.getFullYear()),
    long: d.toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" }),
  };
};

export const TRACKS = [
  {
    title: "Historia de un Amor (Daastaan-e Yek Eshq)",
    description: "The beloved Latin bolero, sung in Persian — East and West in one melody.",
    category: "Latin · Persian",
    url: "https://soundcloud.com/kam-ran-2/historia-de-un-amor-daastaan-e-yek-eshq",
  },
  {
    title: "Inchu Heratzar",
    description: "Armenian folk song of longing, carried on clarinet and voice.",
    category: "Armenian Folk",
    url: "https://soundcloud.com/kam-ran-2/inchu-heratzar-armenian-folk",
  },
  {
    title: "Ti Tha Yino, Ego Me Sena",
    description: "\u201CWhat shall I become, I with you?\u201D — a Greek song of longing, sung with heart.",
    category: "Greek",
    url: "https://soundcloud.com/kam-ran-2/ti-tha-yino-ego-me-sena-what-shall-i-become-i-with-you",
  },
];

export const ALBUMS = [
  {
    title: "Music From the Middle East & Beyond",
    year: "2003",
    note: "The breakthrough recording — topped Austin's world-music charts.",
  },
  {
    title: "Live from Austin, Texas",
    year: "2015",
    note: "Music from the Middle East, Southwest Asia & the Balkans, with the Austin International Folk Dancers.",
  },
];

export const VIDEOS = [
  {
    youtubeId: "P8_uwggJxzk",
    title: "Willow (Itia) — Greek Folk Dance",
    note: "Live performance",
  },
  {
    youtubeId: "5JkVfmca35E",
    title: "Gallery Opening, 2019",
    note: "Live performance",
  },
  {
    youtubeId: "xvxK0QiluBM",
    title: "Music at Home — with The Biscuit Brothers",
    note: "Session",
  },
];

export const GALLERY = [
  { src: IMAGES.patioWide, alt: "1001 Nights Orchestra performing under string lights on the patio at Chocolatería San Ginés, Austin", caption: "Music on the Patio — San Ginés, 2026" },
  { src: IMAGES.patioClose, alt: "Clarinet, bass, riq, darbuka, accordion and guitar mid-set on a wooden patio", caption: "Mid-set — San Ginés" },
  { src: "/photos/whirling-dancer.jpg", alt: "A whirling dancer in white spins before the orchestra on a concert stage, with daf, tabla, accordion and violin behind her", caption: "Whirling dancer — in concert" },
  { src: "/images/band-ensemble-bw.jpg", alt: "Archival black and white group portrait of the 1001 Nights Orchestra ensemble", caption: "From the archive — the ensemble" },
];

export const MILESTONES = [
  { year: "1987", text: "First 1001 Nights gathering at Chicago House, Austin." },
  { year: "2000", text: "Kamran Hooshmand and Javier Palacios create Ojalá, ultimately bringing Latin American melodies into our repertoire." },
  { year: "2003", text: "The band releases its first album: Music From the Middle East & Beyond." },
  { year: "2008", text: "Kamran and the orchestra help create Austin's annual Nowruz Festival at Central Market." },
  { year: "2015", text: "Live from Austin, Texas released with the Austin International Folk Dancers." },
  { year: "2016", text: "Official SXSW showcase artist. Founder Kamran Hooshmand passes away; the ensemble carries his repertoire forward." },
  { year: "Today", text: "Austin's longest-running Middle Eastern ensemble — the Middle East, Latin America and the Balkans in one sound." },
];

export const MUSICIANS = [
  {
    name: "Don Weeda",
    role: "Accordion",
    bio: "Brings Balkan energy and Eastern phrasing to our repertoire with his accordion\u2019s expansive and expressive voice.",
    image: "/photos/don.jpg",
  },
  {
    name: "Ken Maranian",
    role: "Clarinet",
    bio: "Draws on the character and vitality of traditional Armenian dance music, bringing its distinctive phrasing and spirit to the ensemble.",
    image: "/photos/ken.jpg",
  },
  {
    name: "Javier Palacios",
    role: "Vocals",
    bio: "A warm, soulful vocalist whose repertoire brings Spanish-language songs and melodies from across the world into the ensemble\u2019s sound.",
    image: "/photos/javier.jpg",
  },
  {
    name: "Alexis Takvorian",
    role: "Guitar \u00B7 Vocals",
    bio: "Brings Greek vocals, rhythmic drive, and a vibrant musical presence to the orchestra\u2019s wide-ranging repertoire.",
    image: "/photos/alexis.jpg",
  },
  {
    name: "Victor Eijkhout",
    role: "Bass Guitar",
    bio: "Grounds the ensemble with the warm, fluid sound of fretless bass, adding depth and a contemporary edge.",
    image: "/photos/victor.jpg",
  },
  {
    name: "Sonique Visser",
    role: "Percussion \u00B7 Vocals",
    bio: "Adds the pulse and color of the darbuka, while her vocals add a warm, expressive layer to the band.",
    image: "/photos/sonique.jpg?v=2",
  },
];
